import React from 'react';
import PropTypes from 'prop-types';

import { getPeriodForPresentation } from '../../services/utils';

const CompletedTrades = ({ actions, data }) => {
    const allProductContracts = [].concat(...data.map(item => [...item.BUY, ...item.SELL]));
    const completedTrades = allProductContracts.filter(contract => contract.accepted_time !== null);

    return (
        <div className="generic-popup-container" onClick={actions.hideCompletedTradesPopup}>
            <div className="form completedTradesWrapper">
                <h1 className="order-title">Completed Trades</h1>
                <div className="OnlineMarketsGridViewTradesItemWrapper">
                    <div className="OnlineMarketsGridViewTradesHeaderWrapper stickyHeader">
                        <div className="OnlineMarketsGridViewTradesItem">Product</div>
                        <div className="OnlineMarketsGridViewTradesItem">Period</div>
                        <div className="OnlineMarketsGridViewTradesItem">Price</div>
                        <div className="OnlineMarketsGridViewTradesItem">Volume</div>
                        <div className="OnlineMarketsGridViewTradesItem">Time</div>
                    </div>
                    {completedTrades.map(trade => {
                        const datetime = new Date(trade.accepted_time);
                        const date = datetime.toLocaleDateString();
                        const time = datetime.toLocaleTimeString().replaceAll('.', ':');
                        const period = getPeriodForPresentation(trade.trading_period_prefix, trade.trading_period);

                        return (
                            <div key={`trade_${trade.id}`} className="OnlineMarketsGridViewTradesRow">
                                <div className="OnlineMarketsGridViewTradesItem">{trade.product_short_name}</div>
                                <div className="OnlineMarketsGridViewTradesItem">{period}</div>
                                <div className="OnlineMarketsGridViewTradesItem">{`${trade.price} ${trade.currency_id}`}</div>
                                <div className="OnlineMarketsGridViewTradesItem">{`${trade.quantity} ${trade.unit_abbreviation}`}</div>
                                <div className="OnlineMarketsGridViewTradesItem">{`${date} ${time}`}</div>
                            </div>
                        );
                    })}
                </div>
            </div>
        </div>
    );
};

CompletedTrades.propTypes = {
    actions: PropTypes.shape({
        hideCompletedTradesPopup: PropTypes.func.isRequired,
    }),
    data: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
};

export default CompletedTrades;



// WEBPACK FOOTER //
// ./source/screens/orders/CompletedTrades.js